import Swiper from "swiper";
import { Autoplay, Navigation, Pagination, Parallax } from "swiper/modules";

// Feature to handle multiple slides block
const sliderCards = document.querySelectorAll('.cards-carousel');
sliderCards.forEach(el=>{
  const sliderCardsId = el.dataset.slideid;
   new Swiper(`.cards-carousel-${sliderCardsId}`, {
	    modules: [Navigation, Pagination],
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		loop:true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			300: {
			slidesPerView: 1.25,
			spaceBetween: 24,
			},
			768: {
			slidesPerView: 1.25,
			spaceBetween: 24,
			},
			1024: {
			slidesPerView: 2.25,
			spaceBetween: 24,
			},
			1400: {
			slidesPerView: 3.35,
			spaceBetween: 24,
			},
		},
	});
})


// Image Slides
const imageSlides = document.querySelectorAll('.swiper-imagesslides');
imageSlides.forEach(el=>{
	  const sliderCardsId = el.dataset.slideid;
	  new Swiper(`.swiper-imagesslides-${sliderCardsId}`, {
      slidesPerView: 1.5,
      spaceBetween: 0,
      centeredSlides: true,
	  loop:true,
    });
})


// marquee Slides
const maruqeeSlides = document.querySelectorAll('.marquee-carousel');
maruqeeSlides.forEach(el=>{
	  const sliderCardsId = el.dataset.slideid;
	  new Swiper(`.marquee-carousel-${sliderCardsId}`, {
	  modules: [Parallax, Autoplay],
      slidesPerView: 1,
      spaceBetween: 0,
	  loop:true,
	  autoplay:2000,
	  parallax:true,
	  breakpoints: {
			640: {
				slidesPerView: 1,
			},
			768: {
				slidesPerView: 1.5,
			},
		},
    });
})